import { createFileRoute } from '@tanstack/react-router';
import { ContractManagementDashboard } from '@/features/contract-management/ContractManagementDashboard';
import { useContext } from 'react';
import { ContractManagementContext } from './contract-management';

export const Route = createFileRoute('/_authenticated/contract-management/')({
  component: ContractManagementIndexPage,
});

export function ContractManagementIndexPage() {
  const { googleAccessToken, onGoogleLogin } = useContext(ContractManagementContext);

  return (
    <ContractManagementDashboard
      googleAccessToken={googleAccessToken}
      onGoogleLogin={onGoogleLogin}
    />
  );
}
